/*
*  AGP events
*  Responsables
*/

import $ from "jquery";

export default class Responsables {

    constructor() {

    }

    // init
    init() {

        $('.table_filter').find("tr").each(function () {
            if ($(this).hasClass('uncheckable')) {
                $(this).find("td.bs-checkbox").html("N/A"); // Remove the checkbox
            }
        });

        var searchInput = $(".fixed-table-toolbar .search input");
        $("#search_place").append(searchInput);

        if($(".__wrap_user_access").length > 0){
            var _offset = $(".__wrap_user_access").offset();
            $('html,body').animate({scrollTop: _offset.top - 100});
        }

        if($(".block-resp").length > 0 ){

            // $(".__wrap_user").toggle();
            // if ($(".__wrap_user").is(':visible')) {
            //     $(".__wrap_access").hide();
            //     var _offset = $(".__wrap_user").offset();
            //     $('html,body').animate({scrollTop: _offset.top - 100});
            // }
            //var _offset = $(".__wrap_user").offset();
            //$('html,body').animate({scrollTop: _offset.top - 100});
        }

        $('.hidden-checkbox > td.bs-checkbox > label').remove();

        // tranmission fiches par click
        $(document).on("click", "._transmission_fiches", function () {
            var rows = 0;
            if ($("input[name='btSelectAll']").is(':checked')) {
                rows = $(".table_filter").bootstrapTable('getData');
            } else {
                rows = $(".table_filter").bootstrapTable('getSelections');
            }
            if (rows.length > 0) {
                if (confirm("vous êtes sur le point de transmettre " + rows.length + " fiche(s). \n Confirmez-vous cette action ?")) {
                    var ids = rows.map(function (item) {
                        return item.id;
                    });

                     $(".__wait_load").find("span").html("Transmission des fiches en cours, <br> merci de patienter...");
                     $(".__wait_load").addClass("_show");
                     document.getElementById('_user_transmis').value = JSON.stringify(ids);
                     document.getElementById('transmited_users').submit();
                }

            } else {
                alert("Merci de sélectionner des fiches avant de les transmettre");
            }

        });


        $(document).on("click", "._help_category > ._header", function () {

            var _this = $(this);
            $(this).next().toggle();
            var _opened = $(this).next();
            if (_opened.is(':visible')) {
                _this.parent().addClass("_opened");
                $("._help_category > ._contain").not(_opened).hide();
                $("._help_category > ._header").not(_this).parent().removeClass("_opened");
            }else{
                _this.parent().removeClass("_opened");
            }

        });

        if ($(".__wrap_user").is(':visible')) {
            var _offset = $(".__wrap_user").offset();
            $('html,body').animate({scrollTop: _offset.top - 100});
        }

        $(document).on("click", "._profil_rights", function () {
            $(".__wrap_access").toggle();
            if ($(".__wrap_access").is(':visible')) {
                $(".__wrap_user").hide();
                var _offset = $(".__wrap_access").offset();
                $('html,body').animate({scrollTop: _offset.top - 100});
            }
        });

        $(document).on("click", "._close_access", function () {
            $(".__wrap_access").hide();
        });

        $(document).on("click", "._close_access", function () {
            $(".__wrap_access").hide();
        });

        $(document).on("click", "._new_user", function () {
            $(".__wrap_user").toggle();
            if ($(".__wrap_user").is(':visible')) {
                $(".__wrap_access").hide();
                var _offset = $(".__wrap_user").offset();
                $('html,body').animate({scrollTop: _offset.top - 100});
            }
        });

        $(document).on("click", "._close_user", function () {
            $(".__wrap_user").hide();
        });
    };

}


